import { TApplicationState } from 'shared/types/redux';
import { EOfferType } from 'shared/types/wantType';

export const selectOfferType = (state: TApplicationState): EOfferType => {
  return state.offerType.value;
};
